import { Box } from '@opendoor/bricks-next';
import type { BoxProps } from '@opendoor/bricks-next';

export const Divider: React.FC<BoxProps> = (props) => {
  return (
    <Box
      tag="hr"
      margin={0}
      borderWidth={0}
      borderTopWidth={1}
      borderStyle="solid"
      borderColor="$borderSecondary"
      width="100%"
      {...props}
    />
  );
};
